import { godownCreate, godownList, openModal, closeModal } from '../../../../../redux/actions/action-creator';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import FormData from 'form-data';
import MasterCreationFooter from '../../../../../components/Footer/Master_Footer/MasterCreationFooter';
import Form from '../../../../../components/Form/Form';
import { prepareFormData, useFormHandler } from '../../../../../components/Custom_Hooks/useFormHandler';
import useClickOutside from '../../../../../components/Custom_Hooks/useClickOutsSide';
import { useInputAction } from '../../../../../components/Custom_Hooks/useInputAction';
import InputField from '../../../../../components/Input/InputField';
import DropdownLayout_1 from '../../../../../components/Dropdown/DropdownLayout_1';
import useData from '../../../../../components/Custom_Hooks/useData';
import { usePermission } from '../../../../../hooks/usePermission';

const GoDown = ({ title, closeModal_sec }) => {

  const dispatch = useDispatch();


  const commonState = useSelector(state => state.common) || {};
  const godown_data = commonState.godown_data || [];
  const modal_state = commonState.modal_state || {};
  const { userData = null } = useSelector(state => state.auth);

  const godown_data_with_primary = React.useMemo(() => [{ id: 'Primary', name: 'Primary' }, ...(godown_data || [])], [godown_data])

  const { add, view } = usePermission('Masters', 'Godowns');

  const initialState = {
    name: '',
    alias_name: '',
    under: 'Primary',
    under_id: 'Primary',
    company_id: userData?.id,
  }
  const { data, setData } = useData(initialState);
  const [nameInput, setNameInput] = useState(null)

  const modalStateRef = useRef(modal_state);

  useEffect(() => {
    modalStateRef.current = modal_state;
  }, [modal_state]);

  const inputRefs = {
    name: useRef(null),
    alias_name: useRef(null),
    under_id: useRef(null),
  };

  function getCurrentInputRef(name) {
    return inputRefs[name] || null;
  }

  const cleanString = (str) => str.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
  const validations = {
    name: (value) => value.trim() !== "",
    alias_name: (value) => value.trim() !== "",
    under_id: (value) => godown_data_with_primary.some(item => cleanString(item.name).toLowerCase()?.includes(cleanString(value).toLowerCase())),
  };

  const refs = Object.keys(inputRefs).reduce((acc, name) => {
    acc[name] = {
      onFocus: () => {
        const ref = getCurrentInputRef(name);
        if (ref) {
          setNameInput(ref)
          ref?.current?.setSelectionRange(0, ref?.current?.value?.length)
        };
        if (name === 'under_id') {
          dispatch(openModal(name))
        }
      },
      onBlur: (value) => {
        if (name === 'name') {
          if (!value.trim()) {
            getCurrentInputRef(name)?.current?.focus();
          }
        }
        if (name === 'under_id') {
          dispatch(closeModal(name))
        }
      },
    };
    return acc;
  }, {});

  const { handleChange, handleFocus, handleBlur, handleKeyDown, setSubmitConfirm, submitConfirm, handleDropdownClick } = useInputAction({
    data,
    setData,
    validations,
    refs,
    check_dropdown: modal_state?.under_id,
    inputRefs
  });

  const validateForm = () => {
    const requiredFields = [
      { field: 'name', message: 'Required Name Field' },
      { field: 'under_id', message: 'Required Under Field' },
    ]

    for (let { field, message } of requiredFields) {
      if (!data?.[field]) {
        toast.error(message, {
          position: toast.POSITION.TOP_CENTER,
        });
        setSubmitConfirm('');
        getCurrentInputRef(field)?.current?.focus();
        return false;
      }
    }
    return true;
  };

  // Function to reset form fields-----------------------------------------
  const resetForm = () => {
    setData(initialState)
  };

  const { handleSubmit, loading, handleFocusReset } = useFormHandler({
    validateForm,
    prepareFormData: () => prepareFormData(data),
    submitForm: (data) => dispatch(godownCreate(data)),
    shortcuts: [
      {
        key: 'a',
        ctrlKey: true,
        action: () => handleSubmit(new Event('submit')),
      },
    ],
    resetForm,
    first_ref: inputRefs?.name,
    closeModal: closeModal_sec,
    setSubmitConfirm,
    submitConfirm
  });

  useEffect(() => {
    const formData = new FormData();
    formData.append('company_id', userData?.id)
    dispatch(godownList(formData)).catch(err => console.error("Error loading godowns:", err))
  }, [loading])

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === 'Escape') {
        if (submitConfirmRef.current) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setSubmitConfirm('');
          inputRefs?.name?.current?.focus();
          return;
        }
        const activeModals = Object.keys(modalStateRef.current || {}).filter(key => modalStateRef.current[key]);
        const closableModals = ['under_id'];

        const openClosableModals = activeModals.filter(modal => closableModals.includes(modal));
        if (openClosableModals?.length > 0) {
          event.preventDefault();
          event.stopImmediatePropagation();
          openClosableModals.forEach((modal) => {
            dispatch(closeModal(modal));
          })
        } else {
          event.preventDefault();
          event.stopImmediatePropagation();
          document.activeElement?.blur();
          setSubmitConfirm('Quit');
        }
      }
    };
    window.addEventListener('keydown', handleKeyPress, true);
    return () => {
      window.removeEventListener('keydown', handleKeyPress, true);
    };
  }, [dispatch, inputRefs, setSubmitConfirm]);

  const submitConfirmRef = useRef(submitConfirm);
  useEffect(() => {
    submitConfirmRef.current = submitConfirm;
  }, [submitConfirm]);

  const handleClickOutside = (event) => {
    if (nameInput?.current) {
      event.preventDefault();
      nameInput.current.focus();
    }
  };

  const handleClickInside = (event) => {
    let clickedElement = event.target;
    if (clickedElement?.tagName &&
      (clickedElement?.tagName.toLowerCase() === 'input' ||
        clickedElement?.tagName.toLowerCase() === 'textarea')) {
      clickedElement.focus();
    }
  };

  useClickOutside(nameInput, handleClickOutside, handleClickInside);

  const inputFields = [
    { label: 'Name', name: 'name', type: 'text', isRequired: true },
    { label: '(alise)', name: 'alias_name', type: 'text', isRequired: false },
    { label: 'Under', name: 'under_id', type: 'text', isRequired: true },
  ];

  if (!view || !add) {
    if (submitConfirm === 'Quit') {
      setTimeout(() => {
        if (closeModal_sec) {
          closeModal_sec();
        } else {
          window.history.back();
        }
      }, 0);
    }
    return (
      <div className="d-flex justify-content-center align-items-center h-100" style={{ minHeight: '80vh' }}>
        <h3>You do not have permission to access this page.</h3>
      </div>
    );
  }

  return (
    <Form
      handleSubmit={handleSubmit}
      handleKeyDown={handleKeyDown}
      submitConfirm={submitConfirm}
      handleFocusReset={handleFocusReset}
      title={title || 'Godown Creation'}
      loading={loading}
      col='col-5'
      Footer={MasterCreationFooter}
    >
      <div className='row p-0 ps-2 m-0 mb-1'>
        {inputFields?.map(({ label, name, type, isRequired }, index) => (
          <InputField
            key={index}
            lable={label}
            type={type}
            name={name}
            value={data[name]}
            handleChange={handleChange}
            handleBlur={handleBlur}
            handleFocus={handleFocus}
            isRequired={isRequired}
            ref={inputRefs[name]}
          />
        ))}
        {
          modal_state?.under_id && (
            <DropdownLayout_1
              title='List of Godown'
              state={modal_state?.under_id}
              data={data}
              setData={setData}
              input_value={data?.under_id}
              input_key='under_id'
              input_id='under'
              rawData={godown_data_with_primary}
              ref={inputRefs?.under_id}
              inputRefs={inputRefs}
              setSubmitConfirm={setSubmitConfirm}
              handleDropdownClick={handleDropdownClick}
            />)
        }
      </div>
    </Form>
  )
}

export default React.memo(GoDown)

